import React, { useContext } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import appConfig from '../../../constants/config';
import { MasterContainerContext } from '../../Layout/Layout';

interface QRCodeComponentProps {
    className?: string;
}

const QrCode: React.FC<QRCodeComponentProps> = ({ className }) => {
    const qrPageUrl = `${window.location.origin}${appConfig.connectionString.appBaseName}/?qrCode`;
    const logoUrl = `${window.location.origin}${appConfig.connectionString.appBaseName}/images/pwa_app_logo_icon.png`; // Path to your logo image
    const { os } = useContext(MasterContainerContext) || {};
    return (
        <div style={{ position: 'relative', display: 'inline-block', textAlign: 'center', width: '100%', height: '100%' }} className={`qr-code-canvas ${className}`}>
            <QRCodeCanvas
                value={qrPageUrl}
                size={135} // Adjust QR code size as needed
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                level={"H"} // High error correction level to allow image overlay
            />
            <img
                src={logoUrl}
                alt="App Logo"
                style={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '35px',  // Adjust logo size relative to QR code
                    height: '35px', // Adjust logo size relative to QR code
                    borderRadius: '25%', // Optional: make the logo circular
                    zIndex: '1000'
                }}
            />
        </div>
    );
};

export default QrCode;